(() => {
  'use strict';

  window.IS_MOBILE = /\b(Android|BlackBerry|IEMobile|iP(hone|ad|od)|Opera Mini|webOS|Windows Phone)\b/i.test(navigator.userAgent)/* && !window.MSStream*/;
  window.IS_DESKTOP = !IS_MOBILE;
  window.IS_TOUCH_DEVICE = 'ontouchend' in document || !!navigator.msMaxTouchPoints || !!navigator.maxTouchPoints;
})();